/*
  Layout wrapper component that provides NavBar and Footer to all pages
*/

import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import NavBar from './NavBar'
import Footer from './Footer'

function Layout ({ children }) {
  return (
    <>
      <ToastContainer />
      <div className='app-container'>
        <NavBar />
        <div className='main-content'>
          {children}
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Layout
